import { cn } from "@/src/shared/utils/mergeTwClasses";
import { ComponentProps, FC } from "react";

type PageLoaderProps = ComponentProps<"div"> & {
    progress?: number;
};

export const PageLoader: FC<PageLoaderProps> = ({progress, className, ...rest}) => {
    if (progress === undefined) {
        return (
            <div
                className={cn(
                    "animate-spin-infinite h-16 w-16 rounded-full border-8 border-solid border-light-gray border-t-dark-blue",
                    className,
                )}
                {...rest}
            />
        );
    }

    // Normalize progress to be between 0 and 100
    const normalizedProgress = Math.min(Math.max(progress, 0), 100);
    const radius = 28; // Radius of the circle
    const stroke = 8; // Stroke width
    const normalizedRadius = radius - stroke / 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference - (normalizedProgress / 100) * circumference;

    return (
        <div {...rest}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className={cn("block")}
                height={radius * 2}
                width={radius * 2}
            >
                {/* Background circle */}
                <circle
                    stroke="var(--light-gray)"
                    fill="transparent"
                    strokeWidth={stroke}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                />
                {/* Progress circle */}
                <circle
                    stroke="var(--dark-blue)"
                    fill="transparent"
                    strokeWidth={stroke}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                    strokeDasharray={`${circumference} ${circumference}`}
                    strokeDashoffset={strokeDashoffset}
                    style={{
                        transition: "stroke-dashoffset 0.35s",
                        transform: "rotate(-90deg)",
                        transformOrigin: "50% 50%",
                    }}
                />
            </svg>
        </div>
    );
};
